import service from "@/utils/request";

// FM单节详情
export function getCollectionItem(params: any): Promise<any> {
  return service({
    url: "/fm/course/getFreeInfo",
    method: "GET",
    params,
  });
}
